'use client';

import React from 'react';

import clsx from 'clsx';
import { useTranslations } from 'next-intl';

import styles from '../baseFilterStyles.module.css';

import { ButtonExperiment } from '@/components/ButtonExperiment';
import { useCurrentLanguage } from '@/modules/language/useCurrentLanguage';
import { useSearchFilterAggregates } from '@/modules/search/useSearchFilterAggregates';
import { formatNumberWithMetricPrefix } from '@/modules/text/helpers';

type Props = {
  handleClear: () => void;
  handleSubmit: () => void;
  sellerId?: number;
  hideResultsCount?: boolean;
  isFilterableYMALExperiment?: boolean;
};

export function MobileFilterFooter({
  handleClear,
  handleSubmit,
  sellerId,
  hideResultsCount = false,
  isFilterableYMALExperiment,
}: Props) {
  const { data } = useSearchFilterAggregates({
    sellerId,
  });
  const t = useTranslations('search');
  const { language } = useCurrentLanguage();

  const formattedCount = formatNumberWithMetricPrefix(
    data?.data.total || 0,
    language
  );

  return (
    <div className={styles.footer}>
      {!hideResultsCount &&
        !!data?.data.total &&
        t('ResultsCount', { count: formattedCount })}
      <div className={styles.footerButtonsContainer}>
        <ButtonExperiment
          variant="secondary"
          legacyClassName={clsx({
            [styles.roundedFooteButton]: isFilterableYMALExperiment,
          })}
          /**
           * TODO needs ClearFilterAction event:
           * https://depopmarket.atlassian.net/browse/WEB-4976
           */
          onClick={handleClear}
        >
          {t('ResetAll')}
        </ButtonExperiment>
        <ButtonExperiment
          legacyClassName={clsx({
            [styles.roundedFooteButton]: isFilterableYMALExperiment,
          })}
          onClick={handleSubmit}
        >
          {t('ViewItems')}
        </ButtonExperiment>
      </div>
    </div>
  );
}
